const YOUTUBE_VIDEO_ID_REGEX = /(?:youtu\.be\/|youtube\.com\/(?:embed|shorts|live)\/|youtube\.com\/watch\?(?:[^#]*&)?v=)([\w-]+)/;
export const getYoutubeIdentifier = (url) => {
    if (!url) {
        return undefined;
    }
    return url.match(YOUTUBE_VIDEO_ID_REGEX)?.[1] || undefined;
};
